module.exports = __webpack_public_path__ + "static/img/qrcode.5f6480aa.png";